module.exports = __webpack_public_path__ + "img/tarjeta_promocion_freidora_2024.c5349f3a.jpg";